'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"alloy-carousel__border-primary":"alloy-image-picker-module_alloy-carousel__border-primary__f-nS8","alloy-carousel__border-secondary":"alloy-image-picker-module_alloy-carousel__border-secondary__OMIBv","alloy-carousel__thumbnail":"alloy-image-picker-module_alloy-carousel__thumbnail__Qh16O","alloy-carousel__button":"alloy-image-picker-module_alloy-carousel__button__9Kk7q"};

exports.default = styles;
//# sourceMappingURL=alloy-image-picker.module.scss.js.map
